
import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { config } from 'src/environments/environment';


declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private initialized = false;
  constructor(private _router: Router) {
    this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      if (config.enableCookies && this.initialized) {
        setTimeout(() => {
          gtag('js', new Date());
          gtag('config', config.gaTrackingId, { storage: 'none', client_storage: 'none',
            anonymize_ip: true, page_path: e.urlAfterRedirects });
        }, 2000);
      }
    });
  }
  
  init() {
    if (!config.enableCookies || this.initialized) {
      return;
    }
    this.initialized = true;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${config.gaTrackingId}`;
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    const gtagEl = document.createElement('script');
    const gtagBody = document.createTextNode(`
    window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${config.gaTrackingId}', {
        storage: 'none',           
        client_storage: 'none',  
        anonymize_ip: true        
      });
    `);
    gtagEl.appendChild(gtagBody);
    document.body.appendChild(gtagEl);
  }
}